// Submit forms in modals via ajax
// replace the modal content with the server response
// The server response needs to be marked up as a modal

var request = require('../request')
var modal = require('../modal')
var notices = require('../notices')
var formtourlsearchparams = require('../formtourlsearchparams')
var createFolderUpdate = require('./create-folder-update');
var mailMemberArrayLength = require('../modal/modal-mail').getArrayLength
var renderSentMessage = require('../modal/modal-mail').renderSentMessage

var modalcontent = document.getElementById('modal').firstElementChild
var html = document.documentElement

function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function onsubmitHandler(e) {
  var form = e.target
  if (form.dataset.visaForm) {
    e.preventDefault()
    if (form.checkValidity()) {
      form.submit()
    }
  }
  else if (!e.defaultPrevented && form.closest('#modal') && !form.dataset.modalFormDisable) {
    e.preventDefault()
    if (form.checkValidity()) {
      var response = form.dataset.response
      var paramsData = formtourlsearchparams(form)
      //check we have params before sending
      if (paramsData) {
        var res = request.post(form.action, paramsData, 'formEncoded')
        if (response) {
          if (mailMemberArrayLength() > 0) {
            renderSentMessage();
          } else {
            document.querySelector(response).classList.remove('hide')
            form.classList.add('hide')
          }
        } else {
          res.then(function (res) {
            if (form.dataset.modalFormReload) {
              window.location.reload(true)
              return ''
            }
            return res
          })
            .then(function (res) {

              if (IsJsonString(res)) {
                var data = JSON.parse(res);
                if (data.createFolder) {
                  createFolderUpdate.updateSelect(data)
                  createFolderUpdate.updateDropdown(data)
                }
                if (data.message != '') {
                  notices.confirm(data.message)
                  html.classList.remove('modal-open', 'fixed')
                }
              } else {
                var content = new DOMParser()
                  .parseFromString(res, 'text/html')
                  .getElementById('modal')
                if (content && content.children.length > 0) {
                  modal.set(document.createRange().createContextualFragment(content.innerHTML))
                  var ev = new Event('modal-loaded', { bubbles: true })
                  document.dispatchEvent(ev)
                } else {
                  html.classList.remove('modal-open', 'fixed')
                }
              }
            })
        }
      }
    } else {
      e.defaultPrevented = false;
    }
  }
}

function modalFormHide() {
  var form = document.querySelector('#modal form');
  var html = document.documentElement;
  if (form && form.dataset && form.dataset.hideForm == 'true') {
    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.addEventListener('click', function () {
        if (form.checkValidity()) {
          html.classList.remove('modal-open','fixed')
        }
      })
    }
  }
}

document.addEventListener('cm-modal-loaded', modalFormHide)

window.addEventListener('submit', onsubmitHandler)
